// Advanced Markers render only with a Map ID that belongs to the same Google
// Cloud project as VITE_MAPS_API_KEY. The ID is environment-driven so prod can
// pair its own key + Map ID; the fallback is the historical dev-project ID.
export const MAP_ID: string = import.meta.env.VITE_MAPS_MAP_ID || '3e2fbcaf8a1df03f'
